// src/components/Navbar.js
import React, { useContext, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import './styles/Navbar.css';

export default function Navbar() {
  const { user, logout, token } = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => setMenuOpen(false), [loc.pathname]); // close on route change

  return (
    <div className="flex">
      <div className="flex-1">
        <nav className="bg-blue-700 text-white px-4 py-3 shadow-md">
          <div className="logo" style={{ display: "flex", alignItems: "center" }}>
            <img src={require('./assets/logo1.png')} alt="Arosia Logo" />
            {/* Mobile hamburger */}
            <button
              className="menu-toggle"
              aria-label="Toggle menu"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen(v => !v)}
              style={{ marginLeft: "auto" }}
            >
              ☰
            </button>
          </div>

          {/* Links */}
          <ul className={menuOpen ? "show" : ""}>
            <li><Link to="/today-report-viewer/" className="hover:underline">Today’s Report</Link></li>
            <li><Link to="/daily-report-viewer/" className="hover:underline">Reports</Link></li>
            <li><Link to="/forecast" className="hover:underline">Forecast</Link></li>
            <li><Link to="/aiinsights" className="hover:underline">AI Insights</Link></li>
            <li><Link to="/carbon" className="hover:underline">Carbon Savings</Link></li>
            <li><Link to="/master-site-manager" className="hover:underline">MasterSites</Link></li>
            <li><Link to="/masterandsite" className="hover:underline">Sites</Link></li>
            <li>
              <button
                onClick={logout}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded transition"
                style={{ width: "auto" }}
              >
                Logout
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
